module.exports = __webpack_public_path__ + "static/media/MAM---Loading-Globe_Compressed.gif";